import { TypedStartListening, createListenerMiddleware } from '@reduxjs/toolkit'

import { AppDispatch, RootState } from './store'

export const listenerMiddleware = createListenerMiddleware()
type AppStartListening = TypedStartListening<RootState, AppDispatch>

export const startListening = listenerMiddleware.startListening as AppStartListening
